import React from 'react';
import styled from 'styled-components';
import { ImageLazyLoad } from '../ImageLazyLoad';

const SliderImage = styled(ImageLazyLoad)`
  width: 100vw;
  max-height: 55vh;
  position: relative;
  display: inline-block;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: inline-block;
    background: linear-gradient(90deg, rgba(29, 29, 29, 0.95) 13%, rgba(29, 29, 29, 0) 100%);
  }

  & img {
    display: block;
  }
`;

const ReelWrapper = styled.div`
  border-radius: 20px;
  width: 100%;
  margin-right: 40px;
  height: auto;
  position: relative;
`;

const ReelData = styled.div`
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  left: 7%;
  width: fit-content;
  z-index: 1;

  & h3 {
    color: #f7f7f7;
    font-family: AvenirBold;
    font-size: 32px;
    letter-spacing: -0.15px;

    @media (max-width: 767px) {
      color: #f7f7f7;
      font-family: AvenirBold;
      font-size: 28px;
      font-weight: 900;
      text-align: center;
    }
  }
  & p {
    color: #f7f7f7;
    letter-spacing: -0.15px;
    line-height: 1.3;
    font-size: 1.4em;
    text-align: left;
    opacity: 1;
    font-family: Avenir;
    text-align: justify;
  }
`;

export default ({image}) => {

    return (
        <ReelWrapper>
            <ReelData>
                <h3>Watch Latest Reel</h3>
            </ReelData>
            <SliderImage src='parallax2.jpg' />
        </ReelWrapper>
    );
}